export const ErrorMessages = {
    ErrorNotFound: {
        key: 'ErrorNotFound',
        message: 'Something went wrong. Try again later.'
    }
};
